var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"title grey--text text--darken-4"},[_vm._v(_vm._s(_vm.title))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }